<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="label-manage">
    <common-table
      url="/api/supuLabel/getLabelListByPage"
      deleteUrl="/api/supuLabel/deleteLabel"
      :column="column"
      :operate="operate"
      :searchButtons="buttons"
      ref="table"
      :searchForm="searchForm"
    >
      <template v-slot:isWork="scope">
        <el-switch
          v-model="scope.row.isWork == '1'"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="isWorkChange(scope.row)">
        </el-switch>
      </template>
    </common-table>
    <submit-form
      :title="formTitle"
      :visible.sync="formVisible"
      :formData="formData"
      :items="items"
      :rules="rules"
      :action="action"
      addUrl="/api/supuLabel/insertLabel"
      updateUrl="/api/supuLabel/updateLabel"
      :onSubmitCallback="onSubmitCallback"
      :handleClose="handleClose"
    ></submit-form>

  </div>
</template>

<script>
  import global from '../../global/global'
  import utils from '../../utils/utils'
    export default {
        name: "label-manage",
      data(){
        return{
          column:[{
            prop:"name",
            label:"标签名称"
          },{
            prop:"belongClass",
            label:"所属分类",
            formatter:this.belongClassFormatter
          },{
            prop:"isWork",
            label:"生效",
            template:"isWork"
          }],
          buttons:[{
            key:"add",
            name:"添加",
            handleClick:this.onCreate
          }],
          operate:[{
            key:"edit",
            name:"编辑",
            handleClick:this.editRow
          },{
            key:"delete",
            name:"删除"
          }],
          formTitle:"",
          formVisible:false,
          formData:{
            name:"",
            type:"1",
            belongClass:""
          },
          items:[{
            key:"name",
            name:"name",
            label:"标签名称",
            type:"input",
            prop:"name"
          },{
            key:"belongClass",
            name:"belongClass",
            label:"所属分类",
            type:"select",
            prop:"belongClass",
            options:global.belongClass
          }],
          rules:{
            name:[{required: true, message: '请输入标签名称', trigger: 'blur'}],
            belongClass:[{required: true, message: '请请选择所属分类', trigger: 'change'}]
          },
          action:"",
          searchForm:{
            type:"1"
          }
        }
      },
      methods:{
        onCreate(){
          this.formTitle = "新建标签";
          this.formVisible = true;
          this.action = "add";
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            name:"",
            type:"1"
          }
        },
        editRow(row){
          this.formTitle = "编辑标签";
          this.formVisible = true;
          this.action = "edit";
          this.formData = {
            id:row.id,
            name:row.name,
            type:"1",
            belongClass:row.belongClass
          }
        },
        belongClassFormatter(row, column, cellValue, index){
          return global.belongClassText(cellValue);
        },
        isWorkChange(row){
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)'
          });
          let formDate = new FormData();
          formDate.append("id",row.id);
          formDate.append("isWork",row.isWork == "1" ? "0" : "1");
          utils.axiosMethods({
            method:"POST",
            data:formDate,
            url:"/api/supuLabel/updateLabel",
            callback:(res => {
              loading.close()
              if(res.data.code == 0){
                this.$refs['table'].getData();
                this.$message.success(res.data.msg);
              }else{
                this.$message.error(res.data.msg);
              }
            }),
            catch:(error => {
              loading.close();
              this.$message.error(error.response.data.message)
            })
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supu/labelManage.vue